export const DetailsConstants = {
    FETCH_DETAILS_REQUEST : 'FETCH_DETAILS_REQUEST',
    FETCH_DETAILS_SUCCESS : 'FETCH_DETAILS_SUCCESS',
    FETCH_DETAILS_FAILURE : 'FETCH_DETAILS_FAILURE',

    FETCH_CATEGORY_REQUEST : 'FETCH_CATEGORY_REQUEST',
    FETCH_CATEGORY_SUCCESS : 'FETCH_CATEGORY_SUCCESS',
    FETCH_CATEGORY_FAILURE : 'FETCH_CATEGORY_FAILURE'
}